import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./policies.css";
export type PolicySection = { id: string; title: string; paragraphs: string[] };
export default function PolicyPage({
  title,
  intro,
  sections,
  updated = "29 September 2026",
}: {
  title: string;
  intro: string;
  sections: PolicySection[];
  updated?: string;
}) {
  const { hash } = useLocation();
  useEffect(() => {
    const section = sections.find(section => `#${section.id}` === hash);
    if (section) document.getElementById(section.id)?.scrollIntoView({ block: "start", behavior: "auto" });
  }, [title, hash, sections]);
  return (
    <main className="policy-page">
      <header className="policy-hero">
        <div className="policy-wrap">
          <p className="policy-eyebrow">TECHNOGENIOUS · CUSTOMER INFORMATION</p>
          <h1>{title}</h1>
          <p>{intro}</p>
          <p className="policy-date">Updated {updated}</p>
        </div>
      </header>
      <div className="policy-wrap policy-layout">
        <aside>
          <nav aria-label={`${title} contents`}>
            <strong>On this page</strong>
            {sections.map((s) => (
              <a key={s.id} href={`#${s.id}`}>
                {s.title}
              </a>
            ))}
          </nav>
          <nav aria-label="Store policies">
            <strong>Related policies</strong>
            <Link to="/warranties">Warranties</Link>
            <Link to="/termscondition">Terms & conditions</Link>
            <Link to="/privacy-policy">Privacy policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </nav>
        </aside>
        <div>
          {sections.map((s) => (
            <section id={s.id} key={s.id}>
              <h2>{s.title}</h2>
              {s.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </section>
          ))}
          <section className="policy-contact">
            <h2>Questions? Talk to our team.</h2>
            <p>
              Technogenious Solutions Ltd. · Shop 4B, 17 Molynes Road,
              Kingston, Jamaica.
            </p>
            <a href="mailto:technogeniousja@gmail.com">
              technogeniousja@gmail.com
            </a>
            <a href="tel:+18766484163">+1 (876) 648-4163</a>
            <Link to="/contact">Contact & store details →</Link>
          </section>
        </div>
      </div>
    </main>
  );
}
